export const keys = [
    // eslint-disable-next-line max-len
    'contractCode', 'projectCode', 'businessType', 'developmentUnitName', 'developmentUnit', 'validTime', 'failTime', 'bigBusinessType', 'professionalCompany', 'contractAccountOf', 'collectionDays', 'reconciliationInvoicingDays', 'expectedTrafficPlan', 'operationScale', 'grossMarginPlan', 'operatGrossMarginPlan', 'deposit', 'settlementMode', 'acceptanceDays', 'salesStaffName'
];
